<template>
  <div class="item-box-content">
    <div>
      <span class="bold"></span>
      <span class="basic">账期设置</span>
    </div>
    <div v-if="
        $route.query.type === '待审核' ||isTrue
      ">
      <div class="config-instruction" style="display: flex;">
        <div class="el-icon-warning-outline"></div>
        <div
          class="look-text"
          v-if="queryParams.payType === '先货后款'"
        >说明：设置预付款后，合同签订后，预付款部分允许提交付款申请；产品全部入库后，货款部分款项允许提交付款申请；提交付款申请后，款项计为已到期应付账款；设置质保金后，自入库之日起计算质保期，质保期结束后，质保金已到期应付账款；合同签订后不得修改付款方式及各阶段金额；</div>

        <div
          v-if="queryParams.payType === '约定账期'"
          class="look-text"
        >说明：约定账期合同无法设置预付款和质保金，可设置约定条件，到达结算日期结算合同中所有已发货产品合同报价，计为已到期账款；合同签订后不得修改付款方式及各阶段金额；</div>
        <div
          v-if="queryParams.payType === '全款发货'"
          class="look-text"
        >说明：全款发货合同一经签署，除质保金外全部款项均允许提交付款申请，提交完毕后计为已到期应付账款；设置质保金后，自入库之日起计算质保期，质保期结束后，质保金计为已到期应付账款合同签订后不得修改付款方式及各阶段金额</div>
      </div>
      <el-form :model="queryParams">
        <el-row>
          <el-col :span="24">
            <el-row>
              <el-col :span="6">
                <el-form-item label="合同金额：" label-width="95px">
                  <span>{{ purchaseTotal | toFixed}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="付款类型：" label-width="95px">
                  <el-select
                    :disabled="isDisabled"
                    v-model="queryParams.payType"
                    @change="onChange(queryParams.payType)"
                  >
                    <el-option
                      v-for="(item, index) in paymentTypeList"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="补充说明：" label-width="95px">
                  <el-input v-model="queryParams.replenMark"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6" style="text-align:right;" v-if="queryParams.payType !== '约定账期'">
                <el-form-item>
                  <el-button @click="addAdvance" type="primary" :disabled="isDisAdvance" plain>添加预付款</el-button>
                  <el-button
                    @click="addQuaGuaDep"
                    type="primary"
                    :disabled="isDisQuaGuaDep"
                    plain
                  >添加质保金</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" v-if="queryParams.payType === '约定账期'">
            <el-row :gutter="10">
              <el-col :span="4">
                <el-form-item label="约定条件：" label-width="95px">
                  <el-select
                    :disabled="isDisabled"
                    v-model="
                      queryParams.purchaseContractAppointment.appointType
                    "
                  >
                    <el-option
                      v-for="(item, index) in appointList"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item>
                  <el-input-number
                    :disabled="isDisabled"
                    :min="1"
                    :precision="0"
                    :controls="false"
                    style="width:100%;"
                    v-model="
                      queryParams.purchaseContractAppointment.appointValue
                    "
                    placeholder="请设置约定天数"
                  ></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="2">
                <el-form-item>天</el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="24" v-if="queryParams.payType !== '约定账期'">
            <el-table
              border
              ref="tableRef"
              :data="list"
              tooltip-effect="dark"
              :header-cell-style="tableHeader"
            >
              <el-table-column prop="payType" label="付款项">
                <template slot-scope="scope">
                  <div v-if="scope.row.payType === '质保金'" class="quality-guarantee-deposit">
                    <el-form label-position="left" style="margin-top: 10px;">
                      <el-form-item :label="scope.row.payType" label-width="70px">
                        <el-select :value="deadline" @change="onChangeSelect" placeholder="请选择质保期限">
                          <el-option
                            v-for="(item, index) in deadlineList"
                            :key="index"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-form>
                  </div>
                  <span v-else>{{ scope.row.payType }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="money" label="金额">
                <template slot-scope="scope">
                  <span
                    v-if="scope.row.isDisabled && scope.row.money !== null&&$route.query.type ==='待审核'"
                  >{{scope.row.money.toFixed(2) }}</span>
                  <span
                    v-else-if="scope.row.isDisabled && scope.row.money !== null&&$route.query.type !=='待审核'"
                  >{{ scope.row.money.toFixed(2) }}</span>
                  <el-input-number
                    style="width:100%;"
                    :precision="2"
                    @blur="blurInputNumber(scope.row, scope.$index)"
                    :max="purchaseTotal"
                    :min="0"
                    :controls="false"
                    v-else
                    v-model="scope.row.money"
                  ></el-input-number>
                </template>
              </el-table-column>
              <el-table-column prop="proportion" label="比例">
                <template slot-scope="scope">
                  <span
                    v-if="scope.row.isDisabled && scope.row.money !== null&&$route.query.type ==='待审核'"
                  >{{parseFloat(scope.row.proportion).toFixed(2) }}%</span>
                  <span
                    v-else-if="scope.row.isDisabled && scope.row.money !== null&&$route.query.type !=='待审核'"
                  >{{ parseFloat(scope.row.proportion).toFixed(2) }}%</span>

                  <el-input-number
                    :controls="false"
                    :precision="2"
                    @blur="blurInputNumberProportion(scope.row, scope.$index)"
                    :min="0"
                    style="width:90%;"
                    v-else
                    v-model="scope.row.proportion"
                  ></el-input-number>
                  <span v-if="!scope.row.isDisabled">%</span>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <span
                    v-if="scope.row.payType !== '货款'"
                    @click="onDelete(scope.row)"
                    class="operation-font-color"
                  >移除</span>
                  <span v-if="scope.row.payType === '货款'">-</span>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div
      v-if="
        $route.query.type === '审核中' ||
          $route.query.type === '审核通过待签署' ||
          $route.query.type === '盖章审批'||!isTrue||$route.query.type === '审核驳回'||$route.query.type === '审核不通过'
      "
    >
      <el-row style="margin:20px 0;">
        <el-col :span="6">合同金额：{{ listUnderReviewList.contractMoney | toFixed}}</el-col>
        <el-col :span="6">付款类型：{{ listUnderReviewList.payType }}</el-col>
        <el-col :span="6">
          <div v-if="!listUnderReviewList.replenMark">补充说明：{{ '--' }}</div>
          <el-tooltip
            v-else
            class="item"
            effect="dark"
            :content=" listUnderReviewList.replenMark"
            placement="top"
          >
            <span class="ellipsis-text">补充说明：{{ listUnderReviewList.replenMark }}</span>
          </el-tooltip>
        </el-col>
      </el-row>
      <el-row
        style="margin:20px 0;"
        v-if="listUnderReviewList.purchaseContractAppointment !== null"
      >
        <el-col :span="6">
          约定条件：
          <span v-if="listUnderReviewList.purchaseContractAppointment.appointType === 1">发货后</span>
          <span v-if="listUnderReviewList.purchaseContractAppointment.appointType === 2">发货+开票后</span>
          <span v-if="listUnderReviewList.purchaseContractAppointment.appointType === 3">开票后</span>
        </el-col>
        <el-col :span="6">
          约定天数：{{
          listUnderReviewList.purchaseContractAppointment.appointValue+'天'
          }}
        </el-col>
      </el-row>
      <div
        style="margin:20px 0;display: flex;"
        v-if="
          $route.query.type === '审核中' ||
          $route.query.type === '盖章审批' ||
            $route.query.type === '审核通过待签署'||
            $route.query.type === '已作废'|| $route.query.type === '审核驳回'

        "
      >
        <i class="el-icon-warning-outline"></i>
        <span
          class="look-text"
          v-if="listUnderReviewList.payType === '先货后款'"
        >说明：设置预付款后，合同签订后，预付款部分允许提交付款申请；产品全部入库后，货款部分款项允许提交付款申请；提交付款申请后，款项计为已到期应付账款；设置质保金后，自入库之日起计算质保期，质保期结束后，质保金已到期应付账款；合同签订后不得修改付款方式及各阶段金额；</span>
        <span
          class="look-text"
          v-if="listUnderReviewList.payType === '全款发货'"
        >说明：全款发货合同一经签署，除质保金外全部款项均允许提交付款申请，提交完毕后计为已到期应付账款；设置质保金后，自入库之日起计算质保期，质保期结束后，质保金计为已到期应付账款合同签订后不得修改付款方式及各阶段金额；</span>
        <span class="look-text" v-if="listUnderReviewList.payType === '约定账期'">
          说明：约定账期合同无法设置预付款和质保金，可设置约定条件，到达结算日期结算合同中所有已发货产品合同报价，计为已到期账款；
          合同签订后不得修改付款方式及各阶段金额；
        </span>
      </div>
      <el-table
        v-if="listUnderReviewList.payType !== '约定账期'"
        border
        ref="tableRef"
        :data="listUnderReview"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
      >
        <el-table-column prop="type" label="付款项"></el-table-column>
        <el-table-column prop="money" label="金额">
          <template v-slot="{ row }">{{row.money | toFixed}}</template>
        </el-table-column>
        <el-table-column label="比例">
          <template slot-scope="scope">{{ scope.row.proportion }}%</template>
        </el-table-column>
      </el-table>
      <div
        v-if="listUnderReviewList.payType !== '约定账期'&& listUnderReviewList.purchaseContractOtherPayment.guaranteeTime !==null"
        style="height:48px;line-height:48px;background:rgba(246,247,250,1);padding-left:10px;"
      >
        质保期限：{{
        listUnderReviewList.purchaseContractOtherPayment.guaranteeTime
        }}
      </div>
    </div>
  </div>
</template>
<script>
import { paymentTypeList, deadlineList } from '../../util/data'
export default {
  data() {
    return {
      isTrue: false,
      isDisabled: false,
      purchaseTotal: 0,
      queryParams: {
        payType: '约定账期',
        purchaseContractAppointment: {}
      },
      list: [], // 添加质保金,添加预付款
      paymentTypeList: paymentTypeList, // 付款类型
      isDisQuaGuaDep: false, // 添加质保金按钮置灰状态
      isDisAdvance: false, // 添加预付款状态
      deadlineList: deadlineList, // 质保期限
      deadline: '',
      listUnderReviewList: {
        purchaseContractAppointment: { appointType: '', appointValue: '' },
        purchaseContractOtherPayment: { guaranteeTime: 0 }
      },
      listUnderReview: [],
      appointList: [
        { value: 1, label: '发货后' },
        { value: 2, label: '发货+开票后' },
        { value: 3, label: '开票后' }
      ]
    }
  },
  methods: {
    // 百分比
    blurInputNumberProportion(val, index) {
      if (this.list.length === 1) {
        this.list[0].money = this.purchaseTotal
        this.list[0].proportion = 100
      } else if (this.list.length !== 1) {
        if (isNaN(this.list[index].proportion)) {
          this.list[index].proportion = 0
        }
        let params = 0
        this.list.forEach((item, index) => {
          if (item.payType !== '货款') {
            params += item.proportion
            this.list[index].money = this.purchaseTotal * 0.01 * item.proportion
          }
        })

        if (params > 100) {
          this.$message.error('总数过大')
          this.list[index].money = 0
          this.list[index].proportion = 0
        } else {
          for (let i = 0; i < this.list.length; i++) {
            if (this.list[i].payType === '货款') {
              this.list[i].proportion = 100 - params
              this.list[i].money = this.purchaseTotal * (100 - params) * 0.01
            }
          }
        }
      }
    },
    // 金额
    blurInputNumber(val, index) {
      const number = this.purchaseTotal
      if (this.list.length === 1) {
        this.list[0].money = this.purchaseTotal
        this.list[0].proportion = 100
      } else if (this.list.length !== 1) {
        if (isNaN(this.list[index].money)) {
          this.list[index].money = 0
        }
        let params = 0
        this.list.forEach((item, index) => {
          if (item.payType !== '货款') {
            params += item.money
            this.list[index].proportion = (item.money / this.purchaseTotal) * 100
          }
        })
        if (params > this.purchaseTotal) {
          this.$message.error('总数过大')
          this.list[index].money = 0
          this.list[index].proportion = 0
        } else {
          for (let i = 0; i < this.list.length; i++) {
            if (this.list[i].payType === '货款') {
              this.list[i].money = number - params
              this.list[i].proportion = (this.list[i].money / this.purchaseTotal) * 100
            }
          }
        }
      }
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 接收数据
    onInitial(val, param) {
      this.queryParams = {
        payType: param.payType,
        purchaseContractAppointment: {}
      }
      this.isDisQuaGuaDep = false
      this.isDisAdvance = false
      this.purchaseTotal = val
      if (param.payType !== null) {
        this.list.push({
          payType: '货款',
          money: this.purchaseTotal,
          proportion: 100,
          isDisabled: true
        })
        this.isTrue = false
      } else {
        this.queryParams = {
          payType: '约定账期',
          purchaseContractAppointment: {}
        }
        this.isTrue = true
        this.isDisabled = true
      }
      if (this.$route.query.type === '待审核') {
        this.isDisabled = false
        this.isTrue = true
      }
      if (this.$route.query.type === '待审核') {
        this.list = []
        this.list.push({
          payType: '货款',
          money: this.purchaseTotal,
          proportion: 100,
          isDisabled: true
        })
        this.purchaseTotal = val

        if (param.payType === '约定账期') {
          this.queryParams = param
        } else if (param.payType !== null && this.queryParams.purchaseContractOtherPayment) {
          this.list = []
          const data = JSON.parse(JSON.stringify(param))
          this.queryParams = data
          const money = (
            (this.queryParams.purchaseContractOtherPayment.goodAmount / data.contractMoney) *
            100
          ).toFixed(2)
          this.list.push({
            payType: '货款',
            money: this.queryParams.purchaseContractOtherPayment.goodAmount,
            proportion: money,
            isDisabled: true
          })
          if (this.queryParams.purchaseContractOtherPayment.isAdvance === 1) {
            this.isDisAdvance = true
            const money = (
              (this.queryParams.purchaseContractOtherPayment.advanceAmount / data.contractMoney) *
              100
            ).toFixed(2)
            this.list.unshift({
              payType: '预付款',
              money: this.queryParams.purchaseContractOtherPayment.advanceAmount,
              proportion: money,
              isDisabled: false
            })
          }
          if (this.queryParams.purchaseContractOtherPayment.isGuarantee === 1) {
            this.isDisQuaGuaDep = true
            const money = (
              (this.queryParams.purchaseContractOtherPayment.guaranteeAmount / data.contractMoney) *
              100
            ).toFixed(2)
            this.list.push({
              payType: '质保金',
              money: this.queryParams.purchaseContractOtherPayment.guaranteeAmount,
              proportion: money,
              isDisabled: false
            })
            this.deadline = param.purchaseContractOtherPayment.guaranteeTime
          }
        }
      } else if (
        this.$route.query.type === '审核中' ||
        this.$route.query.type === '盖章审批' ||
        this.$route.query.type === '审核通过待签署' ||
        this.$route.query.type === '审核驳回' ||
        this.$route.query.type === '审核不通过' ||
        (this.$route.query.type === '已作废' && !this.isTrue)
      ) {
        // this.list = []

        this.listUnderReview = []
        const data = JSON.parse(JSON.stringify(param))
        this.listUnderReviewList = data
        if (data.payType !== '约定账期' && this.listUnderReviewList.purchaseContractOtherPayment) {
          this.listUnderReviewList.replenMark = data.purchaseContractOtherPayment.replenMark
          const money = (
            (this.listUnderReviewList.purchaseContractOtherPayment.goodAmount /
              data.contractMoney) *
            100
          ).toFixed(2)
          this.listUnderReview.push({
            type: '货款',
            money: this.listUnderReviewList.purchaseContractOtherPayment.goodAmount,
            proportion: money
          })
          if (this.listUnderReviewList.purchaseContractOtherPayment.isAdvance === 1) {
            const money = (
              (this.listUnderReviewList.purchaseContractOtherPayment.advanceAmount /
                data.contractMoney) *
              100
            ).toFixed(2)
            this.listUnderReview.unshift({
              type: '预付款',
              money: this.listUnderReviewList.purchaseContractOtherPayment.advanceAmount,
              proportion: money
            })
          }
          if (this.listUnderReviewList.purchaseContractOtherPayment.isGuarantee === 1) {
            const money = (
              (this.listUnderReviewList.purchaseContractOtherPayment.guaranteeAmount /
                data.contractMoney) *
              100
            ).toFixed(2)
            this.listUnderReview.push({
              type: '质保金',
              money: this.listUnderReviewList.purchaseContractOtherPayment.guaranteeAmount,
              proportion: money
            })
          }
        } else {
          this.listUnderReviewList.replenMark = data.purchaseContractAppointment.replenMark
        }
      }
    },

    // 添加质保金
    addQuaGuaDep() {
      const params = {
        payType: '质保金',
        money: '',
        proportion: '',
        isDisabled: false
      }
      this.list.push(params)
      this.isDisQuaGuaDep = true
    },
    // 添加预付款
    addAdvance() {
      const params = {
        payType: '预付款',
        money: '',
        proportion: '',
        isDisabled: false
      }
      this.list.unshift(params)
      this.isDisAdvance = true
    },
    // 移除
    onDelete(row) {
      if (row.payType === '质保金') {
        this.isDisQuaGuaDep = false
      } else {
        this.isDisAdvance = false
      }
      const index = this.list.indexOf(row)
      this.list.splice(index, 1)
      this.blurInputNumber()
    },
    onChangeSelect(val) {
      this.deadline = val
      this.$emit(
        'purchaseContractOther',
        JSON.parse(JSON.stringify(this.list)),
        JSON.parse(JSON.stringify(this.queryParams)),
        this.deadline
      )
    },
    // 选择付款类型
    onChange(val) {
      if (val === '约定账期' && this.queryParams.purchaseContractAppointment === null) {
        this.queryParams.purchaseContractAppointment = {
          pcbId: '',
          appointType: null,
          appointValue: ''
        }
      }
      this.$emit(
        'purchaseContractOther',
        JSON.parse(JSON.stringify(this.list)),
        JSON.parse(JSON.stringify(this.queryParams)),
        this.deadline
      )
      // if (val === '期货期款') {
      //   this.$emit('onAlterProduct', '期货期款')
      // } else {
      //   // this.$emit('onAlterProduct')
      // }
    }
  },
  watch: {
    list: {
      handler(newVal) {
        this.$emit(
          'purchaseContractOther',
          JSON.parse(JSON.stringify(this.list)),
          JSON.parse(JSON.stringify(this.queryParams)),
          this.deadline
        )
      },
      deep: true
    },
    queryParams: {
      handler(newVal) {
        this.$emit(
          'purchaseContractOther',
          JSON.parse(JSON.stringify(this.list)),
          JSON.parse(JSON.stringify(this.queryParams)),
          this.deadline
        )
      },
      deep: true
    }
  }
}
</script>
<style lang="scss">
.quality-guarantee-deposit {
  .el-form-item__label {
    font-size: 12px !important;
  }
}
.look-text {
  font-size: 12px;
  color: #d35e5e;
}
</style>
